// Pillows checkout page body: the `#checkout-app` SPA mount point. The
// checkout app lives in the document's React tree (mounted client-side by
// CheckoutApp; the dependency tree is not SSR-safe).
import React from "react";

import { CheckoutApp } from "../../apps/checkout/CheckoutApp";

import styles from "./index.module.scss";

export const CheckoutPageBody = (): React.JSX.Element => {
    return (
        <div className="l-capped-width">
            <div id="checkout-app" className={styles.checkoutAppContainer}>
                <CheckoutApp />
            </div>
        </div>
    );
};
